export default __webpack_public_path__ + "static/media/megane-rs-gallery-5.8697df49.jpg";